<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <!--<base-img-->
      <!--:src="require('@/assets/logo_w.svg')"-->
      <!--class="mr-3"-->
      <!--contain-->
      <!--max-width="148"-->
      <!--width="100%"-->
      <!--/>-->
      <!--class="mr-3 hidden-xs-only"-->

      <base-img :src="require('@/assets/main_logo.png')" contain max-width="228" height="80px" width="100%" />

      <v-spacer />

      <div>
        <v-tabs v-model="tab" :optional="True" align-with-title class="hidden-sm-and-down">
          <!-- <v-tabs-slider color="yellow"></v-tabs-slider> -->
          <v-tab to="/" :exact="true" :ripple="false" active-class="text--primary" class="font-weight-bold">
            {{ 'Home' }}
          </v-tab>
          <v-tab to="order" :ripple="false" active-class="text--primary" class="font-weight-bold">
            {{ 'Order' }}
          </v-tab>
          <!-- <v-tab
            to="order"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
          >
            Q&A
          </v-tab>
          <v-tab
            href="https://erp.ltl.kr"
            :ripple="false"
            target="_blank"
            active-class="text--primary"
            class="font-weight-bold"
          >
            Q&A2
          </v-tab> -->
          <v-tabs>
            <v-btn text small target="_blank" href="https://ltlerp.ltl.kr/"
              style="width: 96px; margin-top: 10px; color: rgba(0, 0, 0, 0.84); font-weight: 700;font-size: 0.875rem;">
              ERP
            </v-btn>
          </v-tabs>
          <v-tab to="about" :exact="false" :ripple="false" active-class="text--primary" class="font-weight-bold"
            min-width="96">
            About
          </v-tab>
          <v-tab to="contact-us" :exact="false" :ripple="false" active-class="text--primary" class="font-weight-bold"
            min-width="96" text>
            Contact
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: 'HomeAppBar',

  components: {
    HomeDrawer: () => import('./Drawer'),
  },
  data: () => ({
    True: true,
    tab: 1,
    drawer: null,
    items: [
      'Home',
      'Order',
      'About',
      'Contact',
    ],
  }),
}
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
